import { render, staticRenderFns } from "./register-fingerprint-dialog.vue?vue&type=template&id=0ee70d05&scoped=true&lang=pug&"
import script from "./register-fingerprint-dialog.vue?vue&type=script&lang=ts&"
export * from "./register-fingerprint-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./register-fingerprint-dialog.vue?vue&type=style&index=0&id=0ee70d05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee70d05",
  null
  
)

export default component.exports